import { render, staticRenderFns } from "./ExternalConnectionModal.vue?vue&type=template&id=8047cca4&scoped=true"
import script from "./ExternalConnectionModal.vue?vue&type=script&lang=js"
export * from "./ExternalConnectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8047cca4",
  null
  
)

export default component.exports